

import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { Branding } from '../../branding';

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(2),
		paddingLeft: "2px",
		paddingRight: "2px"
	},
	border: {
		borderWidth: 1,
		borderStyle: 'solid',
		width: '100%',
	},
	content: {
		paddingTop: 0,
		paddingRight: theme.spacing(1),
		paddingBottom: 0,
		textTransform: "uppercase",
		paddingLeft: theme.spacing(1),
		color: Branding.secondary,
	},
}));

const DividerWithText = ({ children, borderColor }) => {
	const classes = useStyles();

	return (
		<Box className={classes.container}>
			<Box borderColor={borderColor} className={classes.border} />
			<Box component="span" className={classes.content}>
				{children}
			</Box>
			<Box borderColor={borderColor} className={classes.border} />
		</Box>
	);
};

export default DividerWithText;
